import React from 'react'
import Banner from './Banner'
import PortfolioData from './PortfolioData'
import CaseStudy from './CaseStudy'

export default function MainPortfolio() {
  
  return (
    <div><Banner/>
    <PortfolioData/>
    <CaseStudy/>
    </div>
  )
}
